import { render, staticRenderFns } from "./BusDeclaration.vue?vue&type=template&id=50e3cc27"
import script from "./BusDeclaration.vue?vue&type=script&lang=js"
export * from "./BusDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports